import { render, staticRenderFns } from "./PreloaderSVG.vue?vue&type=template&id=162c3054&"
import script from "./PreloaderSVG.vue?vue&type=script&lang=js&"
export * from "./PreloaderSVG.vue?vue&type=script&lang=js&"
import style0 from "./PreloaderSVG.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports